const BASIC = 'basic'
const MULTI_AXIS = 'multi_axis'

export default {
  BASIC,
  MULTI_AXIS  
}
